import { isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js';

const SANDBOX_NUMBERS = ['+1 555-555-0100', '+1 555-555-0111', '+1 555-555-5555'];

// Check if phone number is valid unless we are in sandbox mode
// (since we have a special test number for sandbox)
const checkIsPhoneValid = (phoneNumber: string, isSandbox?: boolean) => {
  try {
    const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber);

    // Check if it matches the sandbox number by comparing the formatted numbers
    const matchesSandboxNumber = SANDBOX_NUMBERS.some(
      n => parsePhoneNumberWithError(n).number === parsedPhoneNumber.number,
    );

    if (isSandbox && matchesSandboxNumber) {
      return true;
    }

    // Use isValidPhoneNumber for validation
    return isValidPhoneNumber(phoneNumber);
  } catch (_) {
    return false;
  }
};

export default checkIsPhoneValid;
